import { Box, Typography } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'
import { Terrain } from '@mui/icons-material'
import { Link } from 'react-router-dom'

interface AdventureContextBannerProps {
  adventureId: string
  adventureName: string
}

export function AdventureContextBanner({ adventureId, adventureName }: AdventureContextBannerProps) {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 2,
        py: 0.75,
        bgcolor: alpha(theme.palette.secondary.main, 0.1),
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Terrain sx={{ fontSize: 18, color: 'secondary.main' }} />
      <Typography variant="caption" sx={{ flex: 1, fontWeight: 500 }} noWrap>
        {adventureName}
      </Typography>
      <Typography
        component={Link}
        to={`/adventures/${adventureId}`}
        variant="caption"
        sx={{
          color: 'secondary.main',
          fontWeight: 600,
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        View
      </Typography>
    </Box>
  )
}
